module.exports = __webpack_public_path__ + "static/media/frames-13.5916f042.jpg";